export default __webpack_public_path__ + "static/media/photo59.7fa1db00.png";